import { Button, Stack } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormProvider } from "@app/components";
import {
  useResponsive,
  useRequestState,
  useAuthCheck,
  useDialog,
} from "@app/hooks";
import { findProductIdBy } from "@app/modules/categories/slice";
import { PATH_DASHBOARD } from "@app/routes/paths";

import { createOrders, resetCreateOrder } from "../slice";
import { selectCreateOrderState } from "../selector";
import { yourDetailsSchema } from "../validators";
import { BookingInfoForm } from "./booking-info-form";
import { PaymentMethods } from "./payments-methods";
import { ConfirmationsCards } from "./confirmation-cards";
import { ProductSummary } from "./products-summary";
import { ProductIdDataState } from "@app/modules/categories/selector";
import { selectIsAuthenticated } from "@app/modules/common";
import { BookingSuccessDialog } from "@app/components/modals/booking-success-dialog";
import { selectMyProfileState } from "@app/modules/my-profile/selector";

export enum RequestType {
  BUY = "Buy",
  SELL = "Sell",
  TEST_DRIVE = "Test Drive",
}

const BookNowPage = () => {
  const [paymentType, setPaymentType] = useState<"credit" | "upi">("credit");
  const isTab = useResponsive("down", "md");
  const isMobile = useResponsive("down", "sm");
  const navigate = useNavigate();
  const { buyProductId } = useParams();
  const dispatch = useDispatch();
  const { startLoginFlow } = useAuthCheck();
  const bookingSuccess = useDialog();

  const { data: productData } = useRequestState({
    stateSelector: ProductIdDataState,
  });

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const { data: profileData } = useRequestState({
    stateSelector: selectMyProfileState,
  });

  console.log("profilee dataaa>>", profileData);

  const methods = useForm({
    resolver: yupResolver(yourDetailsSchema) as any,
    defaultValues: {
      name: profileData?.name || "",
      phoneNumber: profileData?.phoneNumber || "",
      address: "",
      townOrCity: "",
    },
  });

  useEffect(() => {
    methods.reset({
      name:
        `${profileData?.firstName || ""} ${profileData?.lastName || ""}` || "",

      phoneNumber: profileData?.phone || "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData]);

  useEffect(() => {
    if (buyProductId) dispatch(findProductIdBy({ id: buyProductId }));
  }, [buyProductId]);

  const onSubmit = (data: any) => {
    const now = new Date();
    const payload: any = {
      type: "Buy",
      carId: Number(buyProductId),
      firstName: data?.name,
      lastName: "",
      email: "",
      phoneNumber: data?.phoneNumber,
      address: data?.address,
      city: data?.townOrCity,
      totalAmount: productData?.car?.price,
      date: now.toLocaleDateString("en-CA"),
      time: now.toLocaleTimeString("en-GB"),
      notes: null,
    };
    dispatch(createOrders(payload));
  };

  const onSuccess = useCallback(() => {
    dispatch(resetCreateOrder());
    bookingSuccess.show();
  }, []);

  const { loading } = useRequestState({
    stateSelector: selectCreateOrderState,
    onSuccess,
    errorShown: true,
    successMessageShown: true,
  });

  return (
    <>
      <FormProvider methods={methods}>
        <Stack direction={isTab ? "column" : "row"} gap={2} p={2}>
          <Stack flex={2.8} gap={2}>
            <BookingInfoForm isMobile={isMobile} />
            {/* <PaymentMethods
            isMobile={isMobile}
            paymentType={paymentType}
            setPaymentType={setPaymentType}
          /> */}
            <ConfirmationsCards />
          </Stack>
          <Stack flex={1}>
            <ProductSummary
              productData={productData?.car}
              onSubmit={methods.handleSubmit(onSubmit)}
              loading={loading}
            />
          </Stack>
        </Stack>
      </FormProvider>
      <BookingSuccessDialog
        onClose={() => {
          bookingSuccess.hide();
          navigate(PATH_DASHBOARD.home);
        }}
        open={bookingSuccess.visible}
      />
    </>
  );
};

export { BookNowPage };
